import request from '@/utils/request';
// import { mockHome, mockPointDetail1, mockSearch } from './mock';
// import { mockPointDetail1 } from './mock';

export interface Res {
    result: number;
}

export interface VoteRes extends Res {
    code: number;
}

export interface TaskItem {
    taskName: string;
    type: string;
    target: number;
    point: number;
    allPointTake: number;
    dateLimit: number;
    status: number;
    accumulated: number;
    currentChance: number;
    extraInfo: {
        avatar: string;
        name: string;
        uid: number;
    } | null;
}

export interface HomeRes extends Res {
    result: number;
    bucket: string;
    curBucket: string;
    timeInfo: {
        startTime: string;
        endTime: string;
    };
    rankName: string;
    startGap: number; // 倒计时毫秒数
    // 完成任务累计获得票数
    allPointTake: number;
    // 当前待投出票数
    point: number;
    // 当前用户被投票数
    votePoint: number;
    // 加密uid
    uuid: string;
    // 任务列表
    taskList: TaskItem[];
    // 头像
    avatar: string;
    // 昵称
    username: string;
    // 距离上一名票数
    pointGap: number;
    // 排名
    rank: string;
    // 是否白名单用户
    whiteUser: boolean;
}

export interface SearchRes extends Res {
    uid: number;
    point: number; // 票数
    avatar: string;
    userName: string;
    rank: number | string;
    isLiving: boolean;
    code: number;
    pointGap: number | null;
    bucket: string;
}

export interface VoteReq {
    toUid: number;
    amount: number;
}

export type RecordItem = {
    timestamp: number;
    getSource: string;
    amount: number;
    relateKwaiId: string
}

export interface PointDetailRes extends Res {
    LiveMidYearPreheatPointDetail: {
        // 累计获取票数
        allPointTake: number;
      // 累计投出票数
      allPointVote: number;
      // 累计收到投票
      votePoint: number;
      recordList: RecordItem[];
    }
}

export type HomeReq = {
    shareBucket?: string;
    authorId?: number;
}

// 预热主接口
export const getHome = (params:HomeReq = {}):Promise<HomeRes> => {
    if (params.shareBucket) {
        return request.get(`/rest/o/w/live/midyear/preheat/home?shareBucket=${params.shareBucket}`);
    }
    if (params.authorId) {
        return request.get(`/rest/o/w/live/midyear/preheat/home?authorId=${params.authorId}`);
    }
    return request.get('/rest/o/w/live/midyear/preheat/home');
};

// 搜索
export const search = (id: string):Promise<SearchRes> => {
    return request.get(`/rest/o/w/live/midyear/preheat/search?kwaiId=${id}`);
    // return Promise.resolve(mockSearch);
};

// 投票
export const vote = (params: { toUid: number; amount: number }):Promise<VoteRes> => {
    return request.get('/rest/o/w/live/midyear/preheat/vote', { params });
    // return Promise.resolve({ result: 1 });
};

// 弹窗票数明细
export const pointDetail = (): Promise<PointDetailRes> => {
    return request.get('/rest/o/w/live/midyear/preheat/pointDetail');
    // return Promise.resolve(mockPointDetail1);
};

// 分享回调
export const shareCallback = (): Promise<Res> => {
    return request.get('/rest/o/w/live/midyear/preheat/share');
};

// 分享打开
export const shareOpen = (uuid: string): Promise<Res> => {
    return request.get(`/rest/o/w/live/midyear/preheat/open?shareUid=${uuid}`);
};

export interface RankReqItem<T> {
    rankKey: T; // 前端使用，对应的key
    rankListName?: string; // 榜单名称 server
    roleType: 'anchor' | 'user'; // 主播 用户
    limit: number; // 几条数据
    timeType: 'daily' | 'total'; // 日榜 总榜
    targetDate?: string; // 可选，默认当天
    targetUid?: number; // 默认个人信息是自己的，若传此参数就查这个uid的
    groupKeys:string[];// 分组
    page: number;
    pageSize: number;
}
export interface RankReq<T> {
    params: RankReqItem<T>[];
    activityName?: string;
    shareBucket?: string; // 端外 桶字段
    authorId?: number;
}

export interface CommonReward {
    type: string;
    subType: string;
    subId: number;
    unit: number;
    bagGiftId: number;
    name: string;
    picUrl: string;
    bagGiftExpires: number;
    scoreThreshold?:number;
    percentageOfScore?:number;
    percentageOfDiffScore?:number;
    maxUnitCalByScore?:number;
    maxUnitCalByDiffScore?:number;
    calUnitByScore?:boolean;
    addUnitByDiffScore?:boolean;
}

export interface rewardItemType {
    startPosition: number;
    endPosition: number;
    rewards: itemType[];
    newRewards: CommonReward[];
    rewardTexts?: string[];
}

export interface resourceItem {
    icon: string;
    name: string;
}

export interface rewardResourceType {
    [key: string]: resourceItem;
}

export interface RankItemType extends MyrankItemType {
    followed: boolean;
    isLiving: boolean;
    isMyself: boolean;
    preRankScore: number;
}

export interface RankItemTypeFormat extends RankItemType{
    formatScore?:string|number;
}

export interface itemType {
    privilegeKey: string; // 特权字段 如果为null则查rewardType
    rewardType: string; // 钻石/快点/免费礼物
    rewardCount: number; // 数量

    rewardIcon?: string;
    rewardName?: string;
    rewardUnit?: string; // 'd' '' 展示单位

    // 新版字段与任务奖励字段统一，不需要再从rewardResource中查找奖励图片信息
    type: string;
    picUrl: string;
    name: string;
    unit: number;
}

export interface MyrankItemType {
    headUrl: string;
    rank: number | string;
    score: number | string;
    userId: number;
    userName: string;
    oposerScore?: number;
    winTimes?: number;
    userBucket: string;
}

export interface RankRes {
    result:number;
    data: {
        currentUserRank: MyrankItemType; // 根据传入的targetUid确定是主播还是用户的底板信息
        currentAnchorRank: MyrankItemType; // 该字段没有
        eventEndTime: number;
        rankList: RankItemType[];
        totalScore?: number;
    };
    eventsCode: number;
    reward: rewardItemType[];
    rewardResource?: rewardResourceType;
    groupKey:string;
    rule:string;
    rankSize: number;
}


export type RankResMap<T extends string> = {
    [key in T]: RankRes[];
} & { result: number };

// 获取普通榜单
export const getRankInfo: <T extends string>(req: RankReq<T>) => Promise<RankResMap<T>> = async rankReq => {
    return request.post('/rest/o/w/live/v2/revenue/activity/rank/result', {
        data: {
            params: rankReq.params,
            shareBucket: rankReq.shareBucket || '',
            ...(rankReq.authorId ? { authorId: rankReq.authorId } : {}),
            // activityName: rankReq.activityName,
            // ...(rankReq.shareBucket ? { shareBucket: rankReq.shareBucket } : {}),
        },
    });
};